import type { FaireProductEntity } from "../../entity_types/product";

export const atc_updated_fs_rec_11: FaireProductEntity = {
  token: "atc_updated_fs_rec_11",
  type: "product",
  name: "Hudson Manhattan Coffee + Pour-Over Set",
  brandName: "Partners Coffee",
  imageUrl:
    "https://cdn.prerelease.faire.dev/fastly/bdf947ed00310e0384a45e9493a3fe762093c8fd71c319a48683e5fa47a277f9.webp",
  priceDollars: 38,
  msrpDollars: 48,
  description: "Recommended product for ATC flow.",
  tags: ["home", "design", "recommendations"],
  freeShipping: true,
  meta: {
    source: "mock",
    importedAt: "2026-03-25T00:00:00.000Z",
    importedBy: "atc-entity-migration",
  },
};
